<template>
    <div class="artcleMain">
        <p class="current">当前位置：
            <span @click="handleCate">{{ itemCate }}</span>
            <span @click="handleEnableIndex1" v-show="currentName != ''"><i class="el-icon-arrow-right"></i>{{ currentName }}</span>
            <span @click="titleTreeList" v-show="subName != ''"><i class="el-icon-arrow-right"></i>{{ subName }}</span>
        </p>
        <div class="flei" v-show="activeTitle != 0">
            <p class="fleiTitel">分类:</p>
            <div v-show="activeTitle == -2" >
                <p v-for="(item,index) in cateNameListFeil" :key="index"  @click="handleFeilei(item,index)">
                    {{ item.cate_name }}
                </p>
            </div>
            <div v-show="activeTitle == 2">
                <p v-for="(item,index) in cateNameListThree" :key="index" @click="handleFeileiTwo(item,index)">
                    {{ item.cate_name }}
                </p>
            </div>
        </div>
        <div class="artcle-box">
            <div class="menu">
                <!-- <p v-show="activeTitle != -2" style="padding-top: 10px;padding-bottom: 10px;border-bottom: 0.5px solid #f2f2f2; font-weight: 700;">{{ currentName }}</p> -->
                <p class="hoverP" :class="active == index?'activeP':''" v-for="item,index in cateNameList" :key="item.cate_id" :index="index.toString()" @click="getMenuId(item,index)">{{ item.cate_name }}</p>
            </div>
            <div class="artcle-right" >
                <div class="search-page">
                    <div>
                        <Search class="searchInput"  @inputKey="inputKey"></Search>
                    </div>
                    <div>
                        <i class="el-icon-shopping-cart-full" @click="getCart"></i>
                        <el-button type="primary" round @click="company()" >+入驻</el-button>
                    </div>
                </div>
                <div class="enableType">
                    <p @click="HandlePice('uni')" :class="sort_type == 'uni'?'priceActive':''"><span>综合</span></p>
                    <p @click="HandlePice('price')" :class="sort_type == 'price'?'priceActive':''"><span>价格</span></p>
                    <p @click="HandlePice('sales')" :class="sort_type == 'sales'?'priceActive':''"><span>销量</span></p>
                </div>
                <div class="enable-list">
                    <div v-for="item in exableList.items" :key="item.id" class="list-item" @click="handleExableInfo(item)">
                        <div class="commodityImage">
                            <img :src="item.firstFile.FileUrl" style="width: 100%;object-fit: cover;" alt="">
                        </div>
                        <p class="description" style="height: 45px;">{{item.name}}</p>
                        <p style="height: 20px;">{{item.company_name}}</p>
                        <p>编码型号：{{ item.pcode }}</p>
                        <div class="enableFh">
                            <div>{{item.att_item_price_size}}种规格</div>
                        </div>
                        <div class="price" v-if="IsToken">
                            <div>
                                <p class="colorProce" v-if="item.att_item_price == ''">
                                    <span>￥</span>
                                    {{item.price}} 
                                </p>
                                <p class="colorProce" v-if="item.att_item_price != ''">
                                    <span>￥</span>
                                    {{item.att_item_price[0].price}} 
                                </p>
                                <span>/{{ item.unit }}</span> 
                                <!-- <div class="vipPrice"><p>￥20.99</p>会员价</div> -->
                            </div>
                            <!-- <div>
                                <i class="el-icon-circle-plus" style="cursor: pointer;"></i>
                            </div> -->
                        </div>
                        <!-- <div class="youhui">
                            <span>多买多惠</span>
                        </div> -->
                      
                    </div>
                    
                </div>
                <div class="pagination">
                    <el-pagination
                        :hide-on-single-page="hideOnSinglePage"
                        :page-size="20"
                        :pager-count="widthNew?11:5"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
                
            </div>
           
        </div>
    </div>
</template>

<script>
import { TimeSelect } from "element-ui"
import Search from "../search/index.vue"
export default({
    data(){
        return{
            itemSub: [],
            subName: '',
            currentName: '',
            sort_type: 'uni',
            product_types: [ 'product','jifen','service'],
            sort_value: 0,
            exableList: [],
            cate: '',
            s_sub_cate: '',
            sub_cate: '',
            keywords: '',
            hideOnSinglePage: true,
            total: 0,
            itemCate: '',
            widthNew: false,
            active: '0',
            IsToken: false,
            cateNameList: [],
            activeTitle: 0,
            currentId: '',
            itemSubId: '',
            cateNameListFeil: [],
            cateNameListThree: [],
            vsDataS:[]
        }
    },
    components: {
        Search,
    },
    watch: {
        
      
    },
    methods:{
        handleCate(){
            this.activeTitle = -2
            sessionStorage.setItem('enableSub','')
            sessionStorage.setItem('s_subs','')
            this.sub_cate = ''
            this.s_sub_cate = ''
            this.currentName = ''
            this.subName = ''
            let enaItem = JSON.parse(sessionStorage.getItem('enableItem'))

            console.log("000000000000000000000000");
            console.log(this.vsDataS);
            this.vsDataS.forEach((item,index) => {
                if(enaItem.cate_id == item.cate_id){
                    this.active = index
                    this.cateNameListFeil = item.children
                }
            });
            let vsData = this.vsDataS
            this.cateNameList = vsData

            let items = {
                pageNum: 1,
                pageSize: 20,
                cate: this.cate,
                sub_cate: this.sub_cate,
                s_sub_cate: this.s_sub_cate,
                keywords: this.keywords,
                product_types: this.product_types,
                sort_type: this.sort_type,
                sort_value: this.sort_value,
            }
            this.gesListEnable(items)

        },
        handleEnableIndex1(){
            let list = sessionStorage.getItem('enableItem')
            sessionStorage.setItem('s_subs','')
            this.subName = ''
            this.s_sub_cate = ''
            let item = JSON.parse(list)
            let subItem = JSON.parse(sessionStorage.getItem('enableSub'))
            this.cateNameList = item.children
            this.cateNameListThree = subItem.children

            this.activeTitle = 2
            

            item.children.forEach((data,index) => {
                if(data.cate_name == this.currentName){
                    this.active = index
                }
            });

            let items = {
                pageNum: 1,
                pageSize: 20,
                cate: this.cate,
                sub_cate: this.sub_cate,
                s_sub_cate: this.s_sub_cate,
                keywords: this.keywords,
                product_types: this.product_types,
                sort_type: this.sort_type,
                sort_value: this.sort_value,
            }
            this.gesListEnable(items)
            console.log("handleEnableIndex1");

        },
        titleTreeList(){
            let list = sessionStorage.getItem('enableSub')
            
            let item = JSON.parse(list)
           
            this.cateNameList = item.children

            this.activeTitle = 2
            

            item.children.forEach((data,index) => {
                if(data.cate_name == this.currentName){
                    this.active = index
                }
            });
        },
       
        titleList(id){
            let data = {
                //parent_id: id
                parent_cate_value: 'product'
            }
            this.$store.dispatch('enable/listCateNew',data)
                .then(res => {
                    console.log('listCateNew')
                    console.log(res.data)
                    if(res.ok && res.data.length != 0){
                        this.cateNameList = res.data
                        console.log(this.itemSub);
                        if(this.activeTitle == 2){ //点击第二级
                            this.cateNameList.forEach((item,index) => {
                                if(item.cate_id == this.itemSub.cate_id){
                                    this.active = index
                                }
                            });
                        }else if(this.activeTitle == 0){ // 点击第三级
                            let NewS_subs = JSON.parse(sessionStorage.getItem('s_subs'))
                            this.cateNameList.forEach((items,index) => {
                                if(items.cate_id == NewS_subs.cate_id){
                                    this.active = index
                                    console.log("activer--------------");
                                    console.log(this.active);
                                   
                                }
                            })
                        }
                    }
                })
        },
        company(){
            this.$router.push({
                path: '/join'
            })
        },  
        getCart(){
            this.$router.push('/cart')
        },
        inputKey(val){
            this.keywords = val
            let items = {
                pageNum: 1,
                pageSize: 20,
                cate: this.cate,
                sub_cate: this.sub_cate,
                s_sub_cate: this.s_sub_cate,
                keywords: val,
                product_types: this.product_types,
                sort_type: this.sort_type,
                sort_value: this.sort_value,
            }
            this.gesListEnable(items)

        },
      
        gesListEnable(data){
            this.$store.dispatch('enable/listproduct',data)
                .then(res => {
                    console.log('listproduct')
                    console.log(res)
                    if(res.ok){
                        this.exableList = res.data
                        this.total = res.data.total

                        if(this.total <= 20){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }

                    }
                })
        },
       
        getMenuId(item,index){
            this.active = index

        
            if(this.activeTitle == 0){ //第三级
                sessionStorage.setItem('s_subs',JSON.stringify(item))
               
               
                this.subName = item.cate_name
                this.sub_cate = item.parent_id
                this.s_sub_cate = item.cate_id

                // let items = {
                //     pageNum: 1,
                //     pageSize: 20,
                //     cate:  this.cate,
                //     sub_cate: item.parent_id,
                //     s_sub_cate: item.cate_id,
                //     keywords: this.keywords,
                //     product_types: this.product_types,
                //     sort_type: this.sort_type,
                //     sort_value: this.sort_value,
                // }
                // this.gesListEnable(items)
            }else if(this.activeTitle == 2){ //第二级
                this.activeTitle == 2
                sessionStorage.setItem('enableSub',JSON.stringify(item))
                this.itemSubId = item.cate_id
                this.itemSub = item
                this.currentName = item.cate_name
                this.currentId = item.cate_id
                this.cateNameListThree = item.children
                // let data = {
                //     parent_id: this.currentId
                // }
                // this.$store.dispatch('enable/listCateNew',data)
                //     .then(res => {
                //         console.log('listCateNew2')
                //         console.log(res.data)
                //         if(res.ok && res.data.length != 0){
                //             this.cateNameList = res.data

                //             this.activeTitle = 0
                //             this.getMenuId(this.cateNameList[0],0)
                //             let s_sub = this.cateNameList[0]
                //             sessionStorage.setItem('s_subs',JSON.stringify(s_sub))
                //         }
                //     })
            }else if(this.activeTitle == -2){
                this.activeTitle == -2
                sessionStorage.setItem('enableItem',JSON.stringify(item))
                sessionStorage.setItem('enableSub','')
                sessionStorage.setItem('s_subs','')
                this.itemCate = item.cate_name
                this.cate = item.cate_id
                this.itemSubId = ''
                this.s_sub_cate = ''
                this.cateNameListFeil = item.children
                
            }

            let items = {
                pageNum: 1,
                pageSize: 20,
                cate: this.cate,
                sub_cate: this.itemSubId,
                s_sub_cate: this.s_sub_cate,
                keywords: this.keywords,
                product_types: this.product_types,
                sort_type: this.sort_type,
                sort_value: this.sort_value,
            }
            this.gesListEnable(items)
        },
        // MenuList(){
        //     let data = {
        //         parent_cate_value: 'product',
        //     }
        //     this.$store.dispatch('enable/listCateNew',data)
        //         .then(res => {
        //         console.log(res.data)
        //             if(res.ok){
        //                 const DataList = res.data
        //                 this.cateNameListFeil = DataList

                        
                      
                   
                        
        //             }
        //         }).catch(err => {
        //             console.log(err);
        //         })
        // },
        getMenuAll(){
            let items = {
                pageNum: 1,
                pageSize: 20,
                cate: '',
                sub_cate: '',
                s_sub_cate: '',
                keywords: this.keywords,
                product_types: '',
                sort_type: '',
                sort_value: '',
            }
            this.gesListEnable(items)
        },
        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            let items = {
                pageNum: val,
                pageSize: 20,
                cate: this.cate,
                sub_cate: this.sub_cate,
                s_sub_cate: this.s_sub_cate,
                keywords: this.keywords,
                product_types: this.product_types,
                sort_type: this.sort_type,
                sort_value: this.sort_value,
            }
            this.gesListEnable(items)
        },
        handleExableInfo(item){
            console.log(item);
            
            const { href } = this.$router.resolve({
                path: "/enableInfo",
                query: {
                    id: item.id,
                }
            });
            window.open(href, '_blank');
        },
        HandlePice(val){
            this.sort_type = val
            if(val == 'price'){
                this.sort_value = 1
            }
       
            let items = {
                pageNum: 1,
                pageSize: 20,
                cate: this.cate,
                sub_cate: this.itemSubId,
                s_sub_cate: this.s_sub_cate,
                keywords: this.keywords,
                product_types: this.product_types,
                sort_type: this.sort_type,
                sort_value: this.sort_value,
            }
            this.gesListEnable(items)
        },
        handleFeilei(item,index){
            sessionStorage.setItem('enableSub',JSON.stringify(item))
            this.activeTitle = 2
            this.currentName = item.cate_name
            this.itemSubId = item.cate_id
            this.cateNameListThree = item.children
            let list =  this.vsDataS[this.active].children
            this.cateNameList = list
            this.cateNameList.forEach((le,ind) => {
                if(item.cate_id == le.cate_id){
                    this.active  = ind
                }
            });

           

            let items = {
                pageNum: 1,
                pageSize: 20,
                cate: this.cate,
                sub_cate: this.itemSubId,
                s_sub_cate: this.s_sub_cate,
                keywords: this.keywords,
                product_types: this.product_types,
                sort_type: this.sort_type,
                sort_value: this.sort_value,
            }
            this.gesListEnable(items)
           
        },
        handleFeileiTwo(item,index){
            sessionStorage.setItem('s_subs',JSON.stringify(item))
            this.activeTitle = 0
            this.subName = item.cate_name
            this.s_sub_cate = item.cate_id

            const vsData = this.cateNameListThree
            this.cateNameList = vsData
            this.cateNameList.forEach((le,ind) => {
                if(item.cate_id == le.cate_id){
                    this.active  = ind
                }
            });

            let items = {
                pageNum: 1,
                pageSize: 20,
                cate: this.cate,
                sub_cate: this.itemSubId,
                s_sub_cate: this.s_sub_cate,
                keywords: this.keywords,
                product_types: this.product_types,
                sort_type: this.sort_type,
                sort_value: this.sort_value,
            }
            this.gesListEnable(items)
           
        },
        createdList(){
        
             // 第一级
            let item = JSON.parse(sessionStorage.getItem('enableItem'))
            this.itemCate = item.cate_name
            this.cate = item.cate_id
            this.activeTitle =  -2
            let data = {
                    parent_cate_value: 'product',
                }
            this.$store.dispatch('enable/listCateNew',data)
                    .then(res => {
                    console.log(res.data)
                        if(res.ok){
                            const DataList = res.data
                            this.vsDataS = DataList
                        }
                        
                    })
                    
            
            
            if(sessionStorage.getItem('enableSub') != '' && sessionStorage.getItem('s_subs') == ''){ // 如果点击第二级
                this.activeTitle = 2
               // 第二级
                this.itemSub = JSON.parse(sessionStorage.getItem('enableSub'))
                this.cateNameList = item.children 
                item.children.forEach((idList,index)=> {
                    if(idList.cate_id == this.itemSub.cate_id){
                        this.active = index
                    }
                });
                this.currentName =  this.itemSub.cate_name
                this.itemSubId = this.itemSub.cate_id
                
                console.log("99999999999999999999999999999999");
                console.log(item);
                this.cateNameListThree =  this.itemSub.children

            }else if(sessionStorage.getItem('s_subs') != ''){  // 点击三级
                // 第二级
                this.itemSub = JSON.parse(sessionStorage.getItem('enableSub'))
                this.currentName = this.itemSub.cate_name
                //  第三级
                let NewS_subs = JSON.parse(sessionStorage.getItem('s_subs'))
                this.cateNameList = this.itemSub.children
                this.activeTitle = 0
                this.itemSub.children.forEach((items,index) => {
                    if(items.cate_id == NewS_subs.cate_id){
                        this.active = index
                       
                        this.subName = items.cate_name
                        this.s_sub_cate = items.cate_id
                    }
                })
            }else{
                let item = JSON.parse(sessionStorage.getItem('enableItem'))
                this.cateNameListFeil = item.children
                let data = {
                    parent_cate_value: 'product',
                }
                this.$store.dispatch('enable/listCateNew',data)
                    .then(res => {
                    console.log(res.data)
                        if(res.ok){
                            const DataList = res.data
                            this.vsDataS = DataList

                            this.cateNameList = DataList
                            this.cateNameList.forEach((le,ind) => {
                                if(item.cate_id == le.cate_id){
                                    this.active = ind
                                }
                            });
                        
                        }
                    }).catch(err => {
                        console.log(err);
                    })
           
            }
            
            
             let items = {
                pageNum: 1,
                pageSize: 20,
                cate: this.cate,
                sub_cate: this.itemSubId,
                s_sub_cate: this.s_sub_cate,
                keywords: this.keywords,
                product_types: this.product_types,
                sort_type: this.sort_type,
                sort_value: this.sort_value,
            }
            this.gesListEnable(items)

            
            //
            // 
            // this.cateNameList = this.itemSub.children
            // if(sessionStorage.getItem('s_subs') != null){
            //     // 第三级
            //     let NewS_subs = JSON.parse(sessionStorage.getItem('s_subs'))
            //     this.itemSub.children.forEach((items,index) => {
            //         if(items.cate_id == NewS_subs.cate_id){
            //             this.active = index
            //             console.log("activer--------------");
            //             console.log(this.active);
            //             this.subName = items.cate_name
            //             this.s_sub_cate = items.cate_id
            //         }
            //     })
            // }else if(this.itemSub.children.length != 0){
            //     this.subName = this.itemSub.children[0].cate_name
            //     this.s_sub_cate = this.itemSub.children[0].cate_id
            // }else{
            //     this.subName = ''
            //     this.s_sub_cate = ''
            // }
            // this.itemCate = item.cate_name
            // this.cate = item.cate_id
            // this.sub_cate = item.cate_id,
            // this.currentName =  this.itemSub.cate_name
            // this.currentId = this.itemSub.cate_id       

           
        }
    },
    mounted(){
        
    },
    
    created(){
        if(localStorage.getItem('token')){
            this.IsToken = true
        }else{
            this.IsToken = false
        }
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
        // this.MenuList()
        this.createdList()
        
        
    }
})
</script>

<style scoped lang="scss">
.artcleMain{
    width: 1200px;
    padding: 10px 10px;
    margin: 45px auto;
    .current{
        margin-top: -45px;
        position: relative;
        font-size: 17px;
        color: #333;
        span{
            font-size: 16px;
            cursor: pointer;
            color: #666666;
        }
    }
    .flei{
        font-size: 17px;
        margin-top: 10px;
        background-color: #fff;
        padding: 10px 10px;
        display: flex;
        justify-content: flex-start;
        .fleiTitel{
            width: 80px;
            margin-top: 8px;
        }
        div{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-flow: row wrap;
            p{
                margin: 10px 10px;
                font-size: 14px;
                cursor: pointer;
                color: #666666;
            }
            p:hover{
                color: #00a8a8;
            }
        }
    }
    .artcle-box{
        width: 1200px;
        display: flex;
        justify-content: flex-start;
        .menu{
            width: 200px;min-height: 200px;
            font-size: 16px;
            align-self: flex-start;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            p{
                padding: 20px 0 20px 0;
                cursor: pointer;
            }
            .hoverP:hover{
                color: #00a8a8;
            }
            .activeP{
                color: #00a8a8;
                border-bottom: 0.5px solid #00a8a8;
            }
            // .el-menu{
            //     border:0;
            //     .el-menu-item {
            //         background-color: rgba(0, 0, 0, 0.1);
            //         font-size: 18px;
            //         .is-active {
            //             background-color: #fff;
            //             margin-top:1px;
            //         }
            //     }
            //     .el-menu-item:hover{
            //         background-color: #fff;
            //         color: #00a8a8 !important;
            //         margin-top:1px;
            //     }
            // }
        }
        .artcle-right{
            width: 900px;
            flex:1;
            // margin-left: 10px;
            background: #fff;
            .search-page{
                display: flex;
                justify-content: space-between;
                align-items: center;
                div{
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    .searchInput{
                        width: 550px;
                    }
                    i{
                        cursor: pointer;
                        margin-right: 20px;
                        font-size: 30px;
                    }
                    i:hover{
                        color: #4095e5;
                    }
                    .el-button{
                        height: 42px;
                        background: #ff9828;
                        border: 1px solid #ff9828;
                    }
                }
            }
            .enableType{
                padding: 0 30px 5px 20px;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                align-items: center;
                p:hover{
                    color: #00a8a8;
                    // 
                }
                .priceActive{
                    color: #00a8a8;
                    border-bottom: 2px solid #00a8a8;
                }
            }
            .enable-list{
                display: flex;
                justify-content: flex-start;
                flex-flow: row wrap;
                cursor: pointer;
                .list-item{
                    width: 270px;
                    margin: 10px 6px;
                    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                    font-size: 14px;
                    color: #999999;
                    padding: 10px 10px 10px 10px;
                    .commodityImage{
                        width: 270px;
                        height: 270px;
                    }
                    .description{
                
                        margin: 10px 0 10px 0;
                        color: #333;
                        font-size: 18px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        
                    }
                    .enableFh{
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        margin-top: 10px;
                        div{
                            margin-right: 10px;
                            padding: 3px 5px;
                            background: #ffe9c2;
                            color: #333;
                        }
                       
                    }
                    .price{
                        display: flex;
                        justify-content: space-between;
                        align-items: end;
                        font-size: 16px;
                        margin-top: 10px;
                        width: 99%;
                        div{
                            display: flex;
                            justify-content: flex-start;
                            align-items: end;
                            .colorProce{
                                font-size: 18px;
                                color: #ff2f4f;
                            }
                            .vipPrice{
                                padding-right: 5px;
                                font-size: 14px;
                                margin-left: 10px;
                                color: #fff;
                                border: 1px solid black;
                                background: #000;
                                align-items: center;
                                p{
                                    padding: 2px 3px;
                                    border-top-right-radius: 8px;
                                    background: #fff;
                                    color: #333;
                                    margin-right: 5px;
                                }
                            }
                        }
                        span{
                            font-size: 14px;
                        }
                        i{
                            color: #00acc9;
                            float: right;
                        }
                    }
                    .youhui{
                        margin-top: 10px;
                        span{
                            padding: 3px 5px;
                            color: #ff2f4f;
                            border: 1px solid #ff2f4f;
                        }
                    }
                }
            }
            .pagination{
                width: 100%;
                text-align: right;
            }
        }
    }
}
</style>